angular.module('unergie.main')
.factory('DownloadService', ($filter, $timeout) => {
    const download = (url, filename, keepFilename) => {
        const a = document.createElement('a')

        a.href = url

        if (keepFilename) {
            a.download = ''
        } else {
            a.download = filename
        }

        a.target = '_blank'
        a.style = 'visibility: hidden;'

        document.body.appendChild(a)

        $timeout(() => {
            a.click()
        })
    }

    const downloadInvoice = (download_link, id_account) => {
        return download($filter('invoiceDownloadLink')(download_link, id_account), download_link.split('/').pop())
    }

    const downloadFile = (url, keepFilename) => {
        return download(url, url.split('/').pop(), keepFilename)
    }

    const s3Download = (path) => {
        const url = `/api-user/download?path=${path}`
        return download(url, path.split('/').pop())
    }

    return {
        downloadInvoice,
        downloadFile,
        s3Download,
    }
})
